import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DashboardApiService } from './db-api.service';

export interface IssuanceReport {
  credentials_issued_last_quarter: number;
  credentials_issued_last_30_days: number;
  credentials_issued_all_time: number;
  unique_recipient_all_time: number;
}

@Injectable({
  providedIn: 'root',
})
export class IssuanceReportApiService extends DashboardApiService {
  getIssuanceReport(): Observable<IssuanceReport> {
    return this._get(
      `/v1/issuer/organizations/${this.embedding.departmentId}/credential_analytics/department_issuance_report`,
    ).pipe(
      map((res) => this._handleResponse(res, 'issuance')),
      catchError((res) => this._handleError(res)),
    );
  }
}
